import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {PotvrdaOPrijaviSteteDocument} from "./PotvrdaOPrijaviSteteDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: osiguravajuće društvo, lista priloga
export const potvrdaOPrijaviSteteDocumentFields: IntercateKeysMap<PotvrdaOPrijaviSteteDocument, EntityField<PotvrdaOPrijaviSteteDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	insuranceCompanyId: {
		name: "insuranceCompanyId", dataType: EntityFieldDataType._reference, label: "Osiguravajuć kuća",
		validator: { required: false },
		referenceDetails: {
			lookupOptions: () => {return [
				{value: 46478053, label: "Globus osiguranje"},
				{value: 1249360, label: "Generali osiguranje"},
				{value: 1249008, label: "Dunav osiguranje"},
				{value: 1249088, label: "Triglav osiguranje"},
				{value: 35471762, label: "Grawe osiguranje"},
				{value: 1249108, label: "Uniqa neživotno osiguranje"},
				{value: 1249103, label: "AMS osiguranje"},
				{value: 1249115, label: "Sava osiguranje"},
				{value: 1249083, label: "DDOR Novi Sad osiguranje"},
				{value: 1249120, label: "Wiener Stadtische osiguranje"},
				{value: 1249093, label: "Milenijum osiguranje"},
				{value: 1305663, label: "UOS"},
			]}
		},
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<PotvrdaOPrijaviSteteDocument>> = [
	potvrdaOPrijaviSteteDocumentFields.indexingNumber,
	potvrdaOPrijaviSteteDocumentFields.indexingDate,
	potvrdaOPrijaviSteteDocumentFields.documentNumber,
	potvrdaOPrijaviSteteDocumentFields.documentDate,
	potvrdaOPrijaviSteteDocumentFields.assignedTo,
	potvrdaOPrijaviSteteDocumentFields.clientId,
	potvrdaOPrijaviSteteDocumentFields.sectorId,
	potvrdaOPrijaviSteteDocumentFields.insuranceCompanyId,
	potvrdaOPrijaviSteteDocumentFields.tags,
	potvrdaOPrijaviSteteDocumentFields.description,
	potvrdaOPrijaviSteteDocumentFields.parentId
]

export const potvrdaOPrijaviSteteDocumentFieldsDescriptor: EntityFieldsDescriptor<PotvrdaOPrijaviSteteDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
